/* On-brand Kaching slide cart: teksten in de jij-vorm + USP's en betaaliconen onder de afrekenknop. */
(function () {
  var TEXT = {
    'Uw winkelwagen': 'Je winkelmand',
    'Onze andere bestsellers': 'Maak je routine compleet',
    'Doorgaan naar afrekenen': 'Veilig afrekenen'
  };
  var queued = false;

  function swapBadges(root) {
    root.querySelectorAll('.kaching-cart__badge, .kaching-cart-item__price-info *').forEach(function (el) {
      if (el.children.length === 0 && /^U bespaart/.test(el.textContent.trim())) el.textContent = el.textContent.replace('U bespaart', 'Je bespaart');
    });
    root.querySelectorAll('.kaching-cart__badge').forEach(function (el) {
      el.childNodes.forEach(function (n) { if (n.nodeType === 3 && /U bespaart/.test(n.textContent)) n.textContent = n.textContent.replace('U bespaart', 'Je bespaart'); });
    });
  }

  function swapText(root) {
    root.querySelectorAll('.kaching-cart__heading, .kaching-cart-product-upsell-carousel__title, .kaching-cart__checkout-button-label').forEach(function (el) {
      var t = el.textContent.trim();
      if (TEXT[t] && el.textContent !== TEXT[t]) el.textContent = TEXT[t];
    });
  }

  function addExtras(root) {
    var footer = root.querySelector('.kaching-cart__footer');
    var tpl = document.getElementById('lx-cart-extras');
    if (!footer || !tpl || footer.querySelector('.lx-cx')) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var btn = footer.querySelector('.kaching-cart__checkout-button');
    if (btn) btn.after(node); else footer.appendChild(node);
  }

  function run() {
    queued = false;
    document.querySelectorAll('.kaching-cart').forEach(function (root) { swapText(root); swapBadges(root); addExtras(root); });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(run); } }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Prijsvergelijking bij het totaal: oude prijs doorgestreept + "Je bespaart" (bundelkorting, cadeaus en codes).
   Leest /cart.js, dus de bedragen zijn exact wat Shopify rekent. */
(function () {
  var FREE_SHIP = 5500, last = '', busy = false, data = null;
  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function rows(c) {
    var out = [], gifts = {}, disc = {}, save = 0;
    c.items.forEach(function (i) {
      var off = i.original_line_price - i.final_line_price;
      if (off <= 0) return;
      if (i.final_line_price === 0) {
        var n = i.product_title;
        gifts[n] = (gifts[n] || 0) + off;
      } else {
        var t = (i.discounts && i.discounts[0] && i.discounts[0].title) || 'Korting';
        disc[t] = (disc[t] || 0) + off;
      }
    });
    Object.keys(disc).forEach(function (t) { out.push({ l: t, v: disc[t] }); save += disc[t]; });
    Object.keys(gifts).forEach(function (n) { out.push({ l: 'Gratis ' + n.toLowerCase(), v: gifts[n], gift: true }); save += gifts[n]; });
    (c.cart_level_discount_applications || []).forEach(function (d) {
      out.push({ l: 'Code ' + d.title, v: d.total_allocated_amount }); save += d.total_allocated_amount;
    });
    return { rows: out, save: save, orig: c.total_price + save };
  }

  function render(foot) {
    var sub = foot.querySelector('.kaching-cart__subtotal');
    if (!sub || !data) return;
    var r = rows(data);
    var was = sub.querySelector('.lx-cs-was'), line = foot.querySelector('.lx-cs-line');
    if (!r.save) { if (was) was.remove(); if (line) line.remove(); return; }
    var amt = sub.querySelector(':scope > span');
    if (amt && !was) { was = document.createElement('s'); was.className = 'lx-cs-was'; amt.before(was); }
    if (was && was.textContent !== eur(r.orig)) was.textContent = eur(r.orig);
    if (!line) { line = document.createElement('p'); line.className = 'lx-cs-line'; sub.after(line); }
    var t = 'Je bespaart ' + eur(r.save);
    if (line.textContent !== t) line.textContent = t;
  }

  function refresh() {
    var foot = document.querySelector('.kaching-cart .kaching-cart__footer');
    if (!foot) return;
    var sub = foot.querySelector('.kaching-cart__subtotal');
    var key = (sub ? sub.textContent : '') + '|' + document.querySelectorAll('.kaching-cart-item').length;
    if (key === last && data) { render(foot); return; }
    if (busy) return;
    busy = true; last = key;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { data = c; render(foot); })
      .catch(function () {}).then(function () { busy = false; });
  }
  var q = false;
  new MutationObserver(function () { if (!q) { q = true; setTimeout(function () { q = false; refresh(); }, 150); } })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  refresh();
})();


/* Kaching-cart toont soms "Je bespaart 100%" (gratis cadeau) of "-12%": altijd in euro's.
   Bedrag = hoogste prijs in die regel (de oorspronkelijke prijs) x percentage. */
(function () {
  var ORIG = new WeakMap(), LAST = new WeakMap();
  var PCT = /[-−]?\s*(\d+(?:[.,]\d+)?)\s*%/;
  function cents(t) {
    var m = String(t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{3})*)(?:[.,](\d{2}))?/);
    return m ? parseInt(m[1].replace(/[.,]/g, ''), 10) * 100 + (m[2] ? parseInt(m[2], 10) : 0) : null;
  }
  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function run() {
    var root = document.querySelector('.kaching-cart');
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), t;
    while ((t = w.nextNode())) {
      var cur = t.nodeValue;
      if (LAST.get(t) !== cur) ORIG.set(t, cur);
      var o = ORIG.get(t);
      if (!o || !PCT.test(o)) continue;
      var el = t.parentElement;
      if (!el || el.closest('.lx-ups')) continue;
      var line = el.closest('.kaching-cart-item, [class*="cart-item"]');
      if (!line) continue;
      /* kleinste omringende blok met een prijs erin (bij een cadeau binnen een bundelregel = de cadeauprijs, niet de bundel) */
      var box = el, max = 0, amts = [];
      while (box && !max) {
        amts = (box.innerText.replace(cur, '').match(/€\s?\d+(?:[.,]\d{2})?/g) || []).map(cents);
        amts.forEach(function (c) { if (c > max) max = c; });
        if (box === line) break;
        box = box.parentElement;
      }
      if (!max) continue;
      var pct = parseFloat(o.match(PCT)[1].replace(',', '.'));
      /* oude + nieuwe prijs in beeld: echte verschil; anders percentage van de oude prijs */
      var amt = eur(amts.length === 2 && pct < 100 ? Math.abs(amts[0] - amts[1]) : Math.round(max * pct / 100));
      var n = o.replace(PCT, function (m) { return (/^\s/.test(m) ? ' ' : '') + (/bespaar/i.test(o) ? '' : '-') + amt; });
      if (cur !== n) t.nodeValue = n;
      LAST.set(t, n);
    }
  }
  var q = false;
  new MutationObserver(function () { if (!q) { q = true; setTimeout(function () { q = false; run(); }, 150); } })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  run();
})();

/* Gratis-verzendingsbalk bovenin de slide cart, eigen versie met onze grens (lx-ups-map.freeShip, nu €55).
   De Kaching-balk rekent met een eigen drempel uit de app; die verbergen we, deze rekent met het subtotaal na korting. */
(function () {
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  function free() {
    try { return JSON.parse(document.getElementById('lx-ups-map').textContent).freeShip || 5500; } catch (e) { return 5500; }
  }
  function cents(t) {
    var m = String(t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{3})*)(?:[.,](\d{2}))?/);
    return m ? parseInt(m[1].replace(/[.,]/g, ''), 10) * 100 + (m[2] ? parseInt(m[2], 10) : 0) : null;
  }
  function eur(c) { return '\u20ac' + (c / 100).toFixed(2).replace('.', ','); }
  var last = '';
  function run() {
    var cart = document.querySelector('.kaching-cart');
    if (!cart) return;
    /* subtotaal na korting = laatste bedrag in het totaalblok (de doorgestreepte oude prijs staat ervoor) */
    var st = cart.querySelector('.kaching-cart__subtotal'), amt = null;
    if (st) Array.prototype.forEach.call(st.querySelectorAll('span, div, b, strong'), function (e) {
      if (!e.closest('s') && !e.classList.contains('lx-cs-was') && /€\s?\d/.test(e.textContent) && !e.querySelector('span, div, b, strong')) amt = e;
    });
    var items = cart.querySelectorAll('.kaching-cart-item').length;
    var bar = cart.querySelector('.lx-shipbar');
    if (!amt || !items) { if (bar) bar.remove(); cart.classList.remove('lx-own-ship'); last = ''; return; }
    var sub = cents(amt.textContent), F = free();
    if (sub === null) return;
    if (!bar) {
      var anchor = cart.querySelector('.kaching-cart__tiered-promotions-bar') || cart.querySelector('.kaching-cart-item');
      if (!anchor) return;
      bar = document.createElement('div'); bar.className = 'lx-shipbar';
      bar.innerHTML = '<span class="lx-ship">' + TRUCK + 'Gratis verzending</span><p class="lx-shipbar__t"></p><div class="lx-shipbar__track"><span class="lx-shipbar__fill"></span></div>';
      anchor.parentNode.insertBefore(bar, anchor);
      last = '';
    }
    cart.classList.add('lx-own-ship');
    var key = sub + '|' + F;
    if (key === last) return;
    last = key;
    var done = sub >= F;
    bar.classList.toggle('is-free', done);
    bar.querySelector('.lx-ship').style.display = done ? '' : 'none';
    bar.querySelector('.lx-shipbar__t').innerHTML = done ? '' : 'Nog <b>' + eur(F - sub) + '</b> tot gratis verzending';
    bar.querySelector('.lx-shipbar__fill').style.width = Math.min(100, Math.round(sub / F * 100)) + '%';
  }
  var q = false;
  new MutationObserver(function () { if (!q) { q = true; setTimeout(function () { q = false; run(); }, 120); } })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  run();
})();
